// Reports R3e — on-device backup of UNSAVED report drafts (the notes' decision 19 rules, ruling D2: its own IndexedDB
// database `hud_report_drafts`, the notes' database untouched). PHI on the device, so the rules are strict:
//   • An entry holds exactly {userId, reportId, isNew, childId, specialistPatientId, name, fields, content, templateId,
//     base, updatedAt} (fields = {report_date, assessment_date, referred_by}, Phase 2 Q1): `content` is the report's Tiptap JSON doc (what saveDraft writes), `base` the updated_at it is based
//     on, `isNew` = no row yet (reportId is then the device-made id of R3b). Nothing else.
//   • Written only while a draft report has unsaved edits; deleted once the server confirms a save that includes the
//     latest edit, on "close anyway", on finalize and when a conflict is resolved. Never for a finalized, read-only or
//     template editor.
//   • Wiped on EVERY sign-out (index.html _purgeLocalUserState + the shared wipe flag in src/lib/draft-store.js).
//   • A doc over RB_DOC_CAP is not stored (a report has no plain-text mirror to fall back to) — memory only.
import { makeDraftStore } from '../../lib/draft-store.js';

const _store = makeDraftStore({ db: 'hud_report_drafts', label: 'report draft backup' });

export const RB_DOC_CAP = 1024 * 1024;
export function rbAvailable() { return _store.available(); }
// Write/replace one entry — exactly the allowed fields. → true once committed (false: too big / unavailable).
export async function rbPut(e) {
  try { if (JSON.stringify(e.content || null).length > RB_DOC_CAP) return false; } catch (_) { return false; }
  const entry = { userId: String(e.userId), reportId: String(e.reportId), isNew: !!e.isNew, childId: e.childId || null,
    specialistPatientId: e.specialistPatientId || null, name: e.name || '',
    fields: e.fields ? { report_date: e.fields.report_date || null, assessment_date: e.fields.assessment_date || null, referred_by: e.fields.referred_by || null } : null,
    content: e.content || null,
    templateId: e.templateId || null, base: e.base || null, updatedAt: new Date().toISOString() };
  return _store.put(entry.userId, entry.reportId, entry);
}
export async function rbGet(userId, reportId) { return _store.get(userId, reportId); }
export async function rbDel(userId, reportId) { return _store.del(userId, reportId); }
export async function rbAll(userId) { return _store.all(userId); }
